import { createFileRoute, redirect } from '@tanstack/react-router';
import { SUPERVISOR_ROLES, MANAGEMENT_ROLES } from '@munawb/hooks';
import SupervisorPage from '../pages/SupervisorPage';
import { getProfileSync } from '../lib/getProfileSync';

const ALLOWED_ROLES = [...SUPERVISOR_ROLES, ...MANAGEMENT_ROLES];

export const Route = createFileRoute('/supervisor')({
  beforeLoad: () => {
    const profile = getProfileSync();
    if (!profile || profile.status !== 'active') {
      throw redirect({ to: '/' });
    }
    if (!ALLOWED_ROLES.includes(profile.role)) {
      throw redirect({ to: '/' });
    }
  },
  component: SupervisorPage,
});
